import React, { Component } from "react";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

import SliderOne from "../component/slider/SliderOne";
import ServiceTwo from "../elements/service/ServiceTwo";
import Testimonial from "../elements/Testimonial";
import About from "../component/HomeLayout/homeOne/About";
import Portfolio from "../component/HomeLayout/homeOne/Portfolio";
import BlogContent from "../elements/blog/BlogContent";
import BrandTwo from "../elements/BrandTwo";
import FeatureList from "../elements/FeatureList";
import Helmet from "../component/common/Helmet";
import CallAction from "../elements/callaction/CallAction";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../translations";
const ourPrjects = [
  
    {
        url: 'https://almihaniyoun-pro.web.app/',
        imageUrl: 'almihaniyoun-480x470.png',
        title: "Bunat",
        description: "Bunat: Professional services and solutions for your business needs.",
        label: 'Commercial'
    },
   
    {
        url: 'https://immobilier-ndjamena.web.app/',
        imageUrl: 'immobilier-ndjamena-480x470.png',
        title: "Immobilier N'Djamena",
        description: "Immobilier N'Djamena: Real estate solutions and property management services.",
        label: 'Commercial'
    },
 
    {
        url: 'https://alnaqdan.com/',
        imageUrl: 'alnaqdan-480x470.png',
        title: "Al Naqdan",
        description: "Al Naqdan: Financial and economic insights platform.",
        label: 'Fintech'
    },
   

   
]
class MainDemo extends Component{
    static contextType = LanguageContext;


    render(){
        const { language } = this.context;
        const t = translations[language];
        const PostList = BlogContent.slice(0 , 3);
        return(
            <div className="active-dark">
                <Helmet pageTitle="MassDev - Specialist in Modern Web & FinTech Development" />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Slider Area   */}
                <div className="slider-wrapper">
                    <SliderOne />
                </div>
                {/* End Slider Area   */}

                {/* Start About Area */}
                <div className="about-area about-position-top pb--120 bg_color--1">
                    <About />
                </div>
                {/* End About Area */}

                {/* Start Service Area  */}
                <div className="service-area ptb--80  bg_image bg_image--3">
                   <div className="container">
                        <ServiceTwo />
                   </div>
                </div>
                {/* End Service Area  */}

                {/* Start Feature Area */}
                <div className="feature-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <span className="subtitle theme-gradient">{t.homepage.capabilities.subtitle}</span>
                                    <h2>{t.homepage.capabilities.title}</h2>
                                    <p className="d-none d-md-block">{t.homepage.capabilities.description}</p>
                                </div>
                            </div>
                        </div>
                        <FeatureList />
                    </div>
                </div>
                {/* End Feature Area */}

                {/* Start Portfolio Area */}
                <div className="portfolio-area ptb--120 bg_color--5">
                     <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--30">
                                    <span className="subtitle theme-gradient">{t.homepage.works.subtitle}</span>
                                    <h2>{t.homepage.works.title}</h2>
                                    <p className="d-none d-md-block">{t.homepage.works.description}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                   <div className="portfolio-sacousel-inner mb--55">
                        <Portfolio />
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="view-more-btn text-center mt--60">
                                    <a className="rn-button-style--2 btn-solid" href="/explore">
                                        <span>{t.homepage.works.viewAllButton}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}

   {/* Start Call To Action */}
                <CallAction />
                {/* End Call To Action */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Blog Area */}
                <div className="rn-blog-area pt--120 bg_color--1 mb-dec--30 pb--120">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-lg-12 text-center col-md-12 col-sm-12 col-12">
                                <div className="section-title text-center">
                                    <span className="subtitle theme-gradient text-center">{t.homepage.latestProjects.subtitle}</span>
                                    <h2 className="text-center">{t.homepage.latestProjects.title}</h2>
                                    <p className="text-center">{t.homepage.latestProjects.description}</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <div className="blog-btn text-left text-lg-right mt_sm--10 mt_md--10">
                                    <a className="btn-transparent rn-btn-dark" href="/explore"><span className="text">{t.homepage.latestProjects.learnMore}</span></a>
                                </div>
                            </div>
                        </div>
                       
                        <div className="row mt--60 mt_sm--40">
                            {ourPrjects.map((value , i ) => (
                                <div className="col-lg-4 col-md-6 col-12" key={i}>
                                    <div className="blog blog-style--1">
                                        <div className="thumbnail" >
                                            <a href={value.url} target="_blank" rel="noopener noreferrer">
                                                <img className="w-100 "  src={`/assets/images/preview/${value.imageUrl}`} alt={value.title}/>
                                            </a>
                                        </div>
                                        <div className="content">
                                            <p className="blogtype">{value.label}</p>
                                            <h4 className="title"><a href={value.url} target="_blank" rel="noopener noreferrer">{value.title}</a></h4>
                                            <div className="blog-btn">
                                                <a className="rn-btn text-white" href={value.url} target="_blank" rel="noopener noreferrer">{t.homepage.latestProjects.viewProject}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* End Blog Area */}

             
                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation pb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />
                
            </div>
        )
    }
}
export default MainDemo;